import { createColumnHelper } from '@tanstack/react-table';

import { SKU } from 'types/sku';

const col = createColumnHelper<SKU>();

/**
 * The columns named on ClickUp 86aykbquv. manufacturer is a manufacturers_mst
 * ref, so the name comes from the joined document — the stored field is an id.
 */
export const buildSkuEquipmentColumns = () => [
  col.accessor((sku) => sku?.category || '-', {
    id: 'category',
    header: 'Category',
    minSize: 150,
  }),
  col.accessor((sku) => sku?.name || '-', {
    id: 'name',
    header: 'SKU Name',
    minSize: 200,
  }),
  col.accessor((sku) => sku?.manufacturerDetails?.name || '-', {
    id: 'manufacturer',
    header: 'Manufacturer',
    minSize: 150,
  }),
];
